import { transport } from 'config/transport';

export function callApiGetReportDuChiForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/duthuchi/duchi`, { params: { academicYear } });
}
